import React, {Component} from 'react';
import {Input} from "reactstrap";
import CardRow from "../../../Styled/Card/CardRow.jsx";
import CardCol from "../../../Styled/Card/CardCol.jsx";


class FilterItSkills extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null
    }
  }
  onChange = (event) => {
    const value = event.currentTarget.value
    this.setState({ value: value });
  };

  onSubmitFilter = () => {
    const {value} = this.state

    this.props.onChange({
      itSkills: [value]
    })
  }

  render() {
    return (
      <CardRow direction="column" gap="1rem 0" align="center">
        <CardCol>
          <Input
            type="text"
            defaultValue={this.state.value}
            name="itSkills"
            className={`filter-it-skills ${this.props.className}`}
            onChange={this.onChange}
            placeholder="Rechercher un outil"
          />
        </CardCol>
        <CardCol>
          <button type={"button"} className="btn btn-primary" onClick={this.onSubmitFilter}>
            Valider
          </button>
        </CardCol>
      </CardRow>
    );
  }
}

export default FilterItSkills